'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocationDescription;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LocationDescription(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      content = _ref.content;

  var classNames = ['type-location_description', moduleClass].join(' ');
  return _react2.default.createElement(
    'div',
    {
      className: classNames
    },
    _react2.default.createElement(
      'h3',
      { className: 'icontitle-title' },
      _react2.default.createElement(
        'svg',
        { className: 'icontitle-icon', width: '38', height: '38', viewBox: '-1 -1 38 38', xmlns: 'http://www.w3.org/2000/svg' },
        _react2.default.createElement('path', { d: 'M36 18c0 9.94-8.06 18-18 18S0 27.94 0 18 8.06 0 18 0s18 8.06 18 18z', stroke: '#FF6138', strokeWidth: '2', strokeLinejoin: 'round', fill: 'none' }),
        _react2.default.createElement('path', { d: 'M32.52 18c0 8.02-6.5 14.52-14.52 14.52S3.48 26.02 3.48 18 9.98 3.48 18 3.48 32.52 9.98 32.52 18z', stroke: '#FF6138', strokeWidth: '2', strokeLinejoin: 'round', fill: 'none' }),
        _react2.default.createElement('path', { stroke: '#FF6138', strokeWidth: '2', strokeLinejoin: 'round', fill: 'none', d: 'M9.87 26.13l10.45-5.8-4.64-4.65zm10.45-5.8l5.8-10.46-10.44 5.8M29.6 18h-1.15m-20.9 0H6.4M17.42 6.97h1.16m-1.16 22.06h1.16' }),
        _react2.default.createElement('path', { d: 'M24.36 13.94c.75 1.17 1.2 2.56 1.2 4.06 0 4.17-3.4 7.55-7.56 7.55-1.5 0-2.9-.44-4.06-1.2m-2.3-2.3c-.75-1.16-1.2-2.55-1.2-4.05 0-4.17 3.4-7.55 7.56-7.55 1.5 0 2.9.44 4.06 1.2', stroke: '#FF6138', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }),
        _react2.default.createElement('path', { d: 'M18 0v3.48M36 18h-3.48M18 32.52V36M3.48 18H0', stroke: '#FF6138', strokeWidth: '2', strokeLinejoin: 'round', fill: 'none' })
      ),
      title
    ),
    _react2.default.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: content
      }
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/LocationDescription/LocationDescription.jsx
// module id = 1215
// module chunks = 0